// extracted by mini-css-extract-plugin
module.exports = {"pagesWrapper":"HeaderLInks_pagesWrapper__9e1if","page":"HeaderLInks_page__LdYJK","pageName":"HeaderLInks_pageName__k1Z9X","active":"HeaderLInks_active__P__kx"};